import { render, staticRenderFns } from "./ThreadInput.vue?vue&type=template&id=2b2b6d65&scoped=true&"
import script from "./ThreadInput.vue?vue&type=script&lang=js&"
export * from "./ThreadInput.vue?vue&type=script&lang=js&"
import style0 from "./ThreadInput.vue?vue&type=style&index=0&id=2b2b6d65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b6d65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
